import {ISerializable} from './base';

export class Pattern implements ISerializable<Pattern> {
  id: number | undefined;
  name: string | undefined;
  srcUrl: string | undefined;
  previewUrl: string | undefined;
  backgroundColor: string | undefined;
  accentColors: string[] = [];
  displayOrder: number | undefined;
  collection: PatternCollection | undefined;
  published: boolean | undefined;

  srcFilename: string | undefined;
  previewFilename: string | undefined;

  deserialize(input: any): Pattern {
    this.id = input.id;
    this.name = input.name;
    this.srcUrl = input.srcUrl;
    this.previewUrl = input.previewUrl;
    this.backgroundColor = input.backgroundColor;
    this.displayOrder = input.displayOrder;
    this.accentColors = input.accentColors;
    this.published = input.published;

    if (input.collection) {
      this.collection = new PatternCollection().deserialize(input.collection);
    }

    if (this.srcUrl) {
      this.srcFilename = this.srcUrl.substring(this.srcUrl.lastIndexOf("/") + 1);
    }
    if (this.previewUrl) {
      this.previewFilename = this.previewUrl.substring(this.previewUrl.lastIndexOf("/") + 1);
    }

    return this;
  }
}

export class PatternCollection implements ISerializable<PatternCollection> {
  id: number | undefined;
  name: string | undefined;
  displayOrder: number | undefined;
  published: boolean | undefined;
  patterns: number | undefined;

  deserialize(input: any): PatternCollection {
    this.id = input.id;
    this.name = input.name;
    this.displayOrder = input.displayOrder;
    this.published = input.published;
    this.patterns = input.patterns;
    return this;
  }
}

export class Shape implements ISerializable<Shape> {
  id: number | undefined;
  name: string | undefined;
  srcUrl: string | undefined;
  previewUrl: string | undefined;
  displayOrder: number | undefined;
  collection: ShapeCollection | undefined;
  published: boolean | undefined;

  content: string | undefined;

  deserialize(input: any): Shape {
    this.id = input.id;
    this.name = input.name;
    this.content = input.content;
    this.displayOrder = input.displayOrder;
    this.published = input.published;

    if (input.collection) {
      this.collection = new ShapeCollection().deserialize(input.collection);
    }

    return this;
  }
}

export class ShapeCollection implements ISerializable<ShapeCollection> {
  id: number | undefined;
  name: string | undefined;
  displayOrder: number | undefined;
  published: boolean | undefined;
  shapes: number | undefined;

  deserialize(input: any): ShapeCollection {
    this.id = input.id;
    this.name = input.name;
    this.displayOrder = input.displayOrder;
    this.published = input.published;
    this.shapes = input.shapes;
    return this;
  }
}
